import React from 'react';
import { string } from '../../localization';
import './OKButton.scss';

const okButton = props => {
  const { clickHandler, buttonLabel } = props;
  let label = '';
  if (buttonLabel) {
    label = buttonLabel;
  } else {
    label = string.OK_KEY;
  }
  return (
    <>
      <button type='button' className='okButton' onClick={clickHandler}>
        <text className='button-label'>{label}</text>
      </button>
    </>
  );
};

export default okButton;
